/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetCounselingCountResponse,
  GetCounselingCountResponseFromJSON,
  GetCounselingCountResponseToJSON,
} from "../models";

export interface GetCounselingsCountsRequest {
  from?: string;
  to?: string;
  requestedFrom?: string;
  requestedTo?: string;
  pharmacistId?: number;
  patientId?: number;
  pharmacyId?: number;
  keyword?: string;
  familyAccountId?: number;
  status?: Array<GetCounselingsCountsStatusEnum>;
  billingStatus?: GetCounselingsCountsBillingStatusEnum;
  dispensingStatus?: Array<GetCounselingsCountsDispensingStatusEnum>;
  limit?: number;
  offset?: number;
  orderBy?: GetCounselingsCountsOrderByEnum;
  groupBy?: GetCounselingsCountsGroupByEnum;
  type?: Array<GetCounselingsCountsTypeEnum>;
  resumeStatuses?: Array<GetCounselingsCountsResumeStatusesEnum>;
  includeNonResumed?: boolean;
  requestType?: GetCounselingsCountsRequestTypeEnum;
  autoLinkStatus?: Array<GetCounselingsCountsAutoLinkStatusEnum>;
  acceptCode?: number;
  dateOfBirth?: string;
  creditCardId?: string;
}

/**
 *
 */
export class CounselingCountsApi extends runtime.BaseAPI {
  /**
   * Get counseling counts
   */
  async getCounselingsCountsRaw(
    requestParameters: GetCounselingsCountsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetCounselingCountResponse>> {
    const queryParameters: any = {};

    if (requestParameters.from !== undefined) {
      queryParameters["from"] = tzDate(requestParameters.from).format();
    }

    if (requestParameters.to !== undefined) {
      queryParameters["to"] = tzDate(requestParameters.to).format();
    }

    if (requestParameters.requestedFrom !== undefined) {
      queryParameters["requested_from"] = tzDate(requestParameters.requestedFrom).format();
    }

    if (requestParameters.requestedTo !== undefined) {
      queryParameters["requested_to"] = tzDate(requestParameters.requestedTo).format();
    }

    if (requestParameters.pharmacistId !== undefined) {
      queryParameters["pharmacist_id"] = requestParameters.pharmacistId;
    }

    if (requestParameters.patientId !== undefined) {
      queryParameters["patient_id"] = requestParameters.patientId;
    }

    if (requestParameters.pharmacyId !== undefined) {
      queryParameters["pharmacy_id"] = requestParameters.pharmacyId;
    }

    if (requestParameters.keyword !== undefined) {
      queryParameters["keyword"] = requestParameters.keyword;
    }

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.status) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.billingStatus !== undefined) {
      queryParameters["billing_status"] = requestParameters.billingStatus;
    }

    if (requestParameters.dispensingStatus) {
      queryParameters["dispensing_status"] = requestParameters.dispensingStatus;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    if (requestParameters.orderBy !== undefined) {
      queryParameters["order_by"] = requestParameters.orderBy;
    }

    if (requestParameters.groupBy !== undefined) {
      queryParameters["group_by"] = requestParameters.groupBy;
    }

    if (requestParameters.type) {
      queryParameters["type"] = requestParameters.type;
    }

    if (requestParameters.resumeStatuses) {
      queryParameters["resume_statuses"] = requestParameters.resumeStatuses;
    }

    if (requestParameters.includeNonResumed !== undefined) {
      queryParameters["include_non_resumed"] = requestParameters.includeNonResumed;
    }

    if (requestParameters.requestType !== undefined) {
      queryParameters["request_type"] = requestParameters.requestType;
    }

    if (requestParameters.autoLinkStatus) {
      queryParameters["auto_link_status"] = requestParameters.autoLinkStatus;
    }

    if (requestParameters.acceptCode !== undefined) {
      queryParameters["accept_code"] = requestParameters.acceptCode;
    }

    if (requestParameters.dateOfBirth !== undefined) {
      queryParameters["date_of_birth"] = requestParameters.dateOfBirth;
    }

    if (requestParameters.creditCardId !== undefined) {
      queryParameters["credit_card_id"] = requestParameters.creditCardId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/counts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => GetCounselingCountResponseFromJSON(jsonValue));
  }

  /**
   * Get counseling counts
   */
  async getCounselingsCounts(
    requestParameters: GetCounselingsCountsRequest,
    initOverrides?: RequestInit
  ): Promise<GetCounselingCountResponse> {
    return promiseRetry(
      (retry) =>
        this.getCounselingsCountsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsStatusEnum {
  Requested = "requested",
  Canceled = "canceled",
  Accepted = "accepted",
  Waiting = "waiting",
  CounselingStarted = "counseling_started",
  CounselingCompleted = "counseling_completed",
  BillingProcessing = "billing_processing",
  BillingCompleted = "billing_completed",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsBillingStatusEnum {
  Initialized = "initialized",
  Registered = "registered",
  Started = "started",
  Succeeded = "succeeded",
  Failed = "failed",
  Canceled = "canceled",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsDispensingStatusEnum {
  Initialized = "initialized",
  Dispensed = "dispensed",
  Notified = "notified",
  Completed = "completed",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsOrderByEnum {
  Date = "date",
  DateDesc = "date_desc",
  RequestedTime = "requested_time",
  RequestedTimeDesc = "requested_time_desc",
  AcceptedTime = "accepted_time",
  AcceptedTimeDesc = "accepted_time_desc",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsGroupByEnum {
  PharmacyIdTime = "pharmacy_id_time",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsTypeEnum {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  FollowUpOnly = "follow_up_only",
  DeliveryOnly = "delivery_only",
  DirectVisit = "direct_visit",
  AiAssistedReception = "ai_assisted_reception",
  OnlineOtcGuidance = "online_otc_guidance",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsResumeStatusesEnum {
  CameBackOnSameDay = "came_back_on_same_day",
  CameBackOnDifferentDay = "came_back_on_different_day",
  PrescriptionPreSubmitted = "prescription_pre_submitted",
  PickUpMissingMedicine = "pick_up_missing_medicine",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsRequestTypeEnum {
  Web = "web",
  Line = "line",
}
/**
 * @export
 * @enum {string}
 */
export enum GetCounselingsCountsAutoLinkStatusEnum {
  Initialized = "initialized",
  Completed = "completed",
  Canceled = "canceled",
}
